<template>
  <div>
    <el-dialog
      title="票付通绑定"
      :visible.sync="showDialog"
      :append-to-body="true"
      width="40%"
    >
      <el-alert :close="false" title="提示" style="margin-bottom: 20px;">
        <div>
          <p>1.您正在为<strong>{{goodsTitle}}</strong>绑定票付通信息。</p>
          <p>2.按下确认键后您做的更改将会生效。</p>
        </div>
      </el-alert>
      <el-table
        :data="pftScenicSku"
        :border="true"
      >
        <el-table-column
          label="规格名称"
          prop="sku_title"
          width="100px"
        ></el-table-column>

        <el-table-column
          label="票付通信息"
          prop="pft_ticket_title"
        >
          <div slot-scope="scope">
            <div size="mini" v-if="scope.row.pft_ticket_title">
              {{scope.row.pft_scenic_title}} -
              {{scope.row.pft_ticket_title}}({{scope.row.pft_ticket_id}})
            </div>
            <el-tag size="mini" v-else type="danger">
              未绑定
            </el-tag>
          </div>
        </el-table-column>

        <el-table-column
          label="操作"
          prop="title"
          width="200px"
        >
          <div slot-scope="scope">
            <el-button size="mini" type="success" @click="choosePftDialog(scope.row.sku_id)">立即绑定
            </el-button>
            <el-button size="mini" @click="cancelPft(scope.$index)">取消绑定</el-button>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="postBind">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="票付通商品列表" :visible.sync="showPftDialog" :append-to-body="true" width="40%">
      <el-table :data="pftScenicList" :border="true">
        <el-table-column label="商品图片" prop="UUimgpath">
          <div slot-scope="scope">
            <img :src="scope.row.UUimgpath" width="50" height="50"
                 @error="fixDefaultImage(scope.$index)">
          </div>
        </el-table-column>
        <el-table-column label="商品id" prop="UUid"></el-table-column>
        <el-table-column label="商品名称" prop="UUtitle"></el-table-column>
        <el-table-column type="expand" width="100" label="选择票券">
          <div slot-scope="scope">
            <el-table :data="scope.row.tickets" :border="true">
              <el-table-column
                label="票券id"
                prop="UUpid"
              >
              </el-table-column>
              <el-table-column
                label="票券id"
                prop="UUtitle"
              >
              </el-table-column>
              <el-table-column
                label="售价"
                prop="UUtprice"
              >
              </el-table-column>
              <el-table-column
                label="操作"
              >
                <div slot-scope="tickets">
                  <el-button type="primary" size="mini" @click="chooseBind(scope.row,tickets.row)">
                    绑定
                  </el-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </el-table-column>
      </el-table>
      <div style="text-align: right;padding: 10px;">
        <el-button type="primary" size="mini" :disabled="page === 1" @click="changePage('diff')">
          上一页
        </el-button>
        <el-button type="primary" size="mini" :disabled="pftScenicList.length < 15"
                   @click="changePage()">下一页
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "i-pft",
    props: {
      productId: {},
      goodsTitle: {},
      show: {}
    },
    data() {
      return {
        currScenic: {},
        showDialog: false,
        showPftDialog: false,
        currSku: '',
        pftScenicSku: [
          {sku_title: '', sku_id: '', pft_info: '', pft_ticket_id: ''}
        ],
        pftScenicList: [],
        loading: false,
        page: 1
      }
    },
    methods: {
      getPftScenicInfos: function () {
        this.$http.request('getScenicPftInfo', {product_id: this.productId}).then((res) => {
          this.pftScenicSku = res.data;
        });
      },
      getPftGoodsList: function () {
        this.$http.request('getPftList', {page: this.page}).then((res) => {
          this.pftScenicList = res.data;
        })
      },
      fixDefaultImage: function (index) {
        this.pftScenicList[index].UUimgpath = 'https://images.pft12301.cc/images/defaultThum.jpg';
      },
      chooseBind: function (scenicInfo, ticketInfo) {
        this.pftScenicSku.forEach((row, index) => {
          if (row.sku_id === this.currSku) {
            this.pftScenicSku[index].pft_scenic_title = scenicInfo.UUtitle;
            this.pftScenicSku[index].pft_scenic_id = scenicInfo.UUid;
            this.pftScenicSku[index].pft_ticket_id = ticketInfo.UUid;
            this.pftScenicSku[index].pft_aid = ticketInfo.UUaid;
            this.pftScenicSku[index].pft_ticket_title = ticketInfo.UUtitle;
            this.pftScenicSku[index].pft_t_price = ticketInfo.UUtprice;
          }
        });
        this.showPftDialog = false;
      },
      choosePftDialog: function (skuId) {
        this.showPftDialog = true;
        this.currSku = skuId;
      },
      cancelPft: function (index) {
        this.pftScenicSku[index].pft_scenic_title = "";
        this.pftScenicSku[index].pft_scenic_id = "";
        this.pftScenicSku[index].pft_ticket_id = "";
        this.pftScenicSku[index].pft_ticket_title = "";
      },
      postBind: function () {
        this.loading = true;
        this.$http.request('bindPft', this.pftScenicSku).then((res) => {
          if (res.status === 'success') {
            this.$message({message: res.message, type: 'success'});
            this.showDialog = false;
          }
          this.loading = false;
        });
      },
      changePage: function (type = 'add') {
        if (type === 'add') {
          this.page = this.page + 1;
        } else {
          if (this.page > 1) {
            this.page = this.page - 1;
          }
        }
        this.getPftGoodsList();
      }
    },
    created: function () {
      this.getPftGoodsList();
      this.getPftScenicInfos();
    },
    watch: {
      showPftDialog: function () {
        if (this.showPftDialog) {
          this.getPftGoodsList();
        }
      },
      scenicInfo: function () {
        this.currScenic = this.scenicInfo;
      },
      show: function () {
        this.showDialog = this.show;
        if (this.show) {
          this.getPftScenicInfos();
        }
      },
      showDialog: function () {
        this.$emit('change', this.showDialog);
      },
      productId: function () {
        this.getPftScenicInfos();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/i-pft.vue